var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0859 7.76283H10.4167V6.55669C10.4167 6.15565 10.0858 5.83301 9.67448 5.83301H8.1901C7.77881 5.83301 7.44792 6.15565 7.44792 6.55669V7.76283H2.7474C2.61133 7.76283 2.5 7.87139 2.5 8.00406V8.48652C2.5 8.61919 2.61133 8.72774 2.7474 8.72774H7.44792V9.93389C7.44792 10.3349 7.77881 10.6576 8.1901 10.6576H9.67448C10.0858 10.6576 10.4167 10.3349 10.4167 9.93389V8.72774H18.0859C18.222 8.72774 18.3333 8.61919 18.3333 8.48652V8.00406C18.3333 7.87139 18.222 7.76283 18.0859 7.76283ZM9.42708 9.69266H8.4375V6.79792H9.42708V9.69266ZM18.0859 12.1049H15.3646V10.8988C15.3646 10.4978 15.0337 10.1751 14.6224 10.1751H13.138C12.7267 10.1751 12.3958 10.4978 12.3958 10.8988V12.1049H2.7474C2.61133 12.1049 2.5 12.2135 2.5 12.3462V12.8286C2.5 12.9613 2.61133 13.0698 2.7474 13.0698H12.3958V14.276C12.3958 14.677 12.7267 14.9997 13.138 14.9997H14.6224C15.0337 14.9997 15.3646 14.677 15.3646 14.276V13.0698H18.0859C18.222 13.0698 18.3333 12.9613 18.3333 12.8286V12.3462C18.3333 12.2135 18.222 12.1049 18.0859 12.1049ZM14.375 14.0348H13.3854V11.14H14.375V14.0348Z",
    fill: "#0e0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControls);
export default __webpack_public_path__ + "static/media/controls.a8ebf47254c99e6f742b196019cdbd6e.svg";
export { ForwardRef as ReactComponent };